export const NON_PROPOSED_APPLICATION_TEXT = {
  REJECT: {
    TEXT: 'Reject',
    DIALOG: {
      TITLE: 'Confirmation',
      CONTENT:
        'Please confirm your decision to reject this application. Once rejected, the applicant will no longer be considered, and this action is irreversible. Do you wish to proceed?',
      CONFIRM: 'Yes',
      CANCEL: 'No',
    },
  },
  EXPORT: 'Export All Application Data',
};
